<template>
  <div class="message">
    <van-nav-bar
    v-if="source==1"
    title="我的消息"
    left-arrow
    :fixed="true"
    @click-left="onClickLeft"
    />
    <van-tabs :style="{'margin-top':source==1?'45px':'0'}" v-model="active" title-active-color="#F6AB00" color="#F6AB00" @click="onClick" sticky>
      <van-tab>
        <div slot="title" style="display:inline-flex">
          评论 <van-tag v-if="comment_nums>0" round type="danger" size="medium">20</van-tag>
        </div>
        <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        :immediate-check="false"
        @load="onLoad"
        >
        <div class="f-12 listhand">通知列表</div>
        <div v-for="item in list" :key="'list_' + item.comment_id">
          <van-swipe-cell>
            <van-cell>
              <template slot="title">
                <div class="message-title"><span class="c-blue">{{item.comment.user.user_name}}</span> 评论我：</div>
                <van-row justify="space-between">
                  <van-col span="22">
                    <span class="ellipsis-2 f-12">
                      {{item.comment.content}}
                    </span>
                  </van-col>
                  <van-col span="2">
                    <van-tag v-if="item.is_read==0" type="danger" round></van-tag>
                  </van-col>
                </van-row>
                <div class="sourtime f-12">{{item.created_at}}</div>
              </template>
            </van-cell>
            <template slot="right">
              <van-button square type="danger" :data-name="0" :data-code="item.comment_id" @click="delMessage" text="删除" />
            </template>
          </van-swipe-cell>
        </div>
      </van-list>
      <div v-if="list.length==0" class="nodata">暂无数据</div>
    </van-tab>
    <van-tab>
      <div slot="title" style="display:inline-flex">
        问答 <van-tag v-if="ask_nums>0" round type="danger" size="medium">20</van-tag>
      </div>
      <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      :immediate-check="false"
      @load="onLoad"
      >
      <div class="f-12 listhand">通知列表</div>
      <div v-for="item in alist" :key="'qlist_' + item.id">
        <van-swipe-cell>
          <van-cell-group>
            <van-cell title="您的提问收到一个新回答，快去看看吧" label="2019-12-12 12:12:12" />
          </van-cell-group>
          <template slot="right">
            <van-button square type="danger" :data-name="1" :data-code="item.id" @click="delMessage" text="删除" />
          </template>
        </van-swipe-cell>
      </div>
    </van-list>
    <div v-if="alist.length==0" class="nodata">暂无数据</div>
  </van-tab>
</van-tabs>
</div>
</template>
<script>
  import list from '../../../api/member/mymessage';
  import { mapState } from 'vuex';
  import { Tab, Tabs, List, Row, Col, Tag, Grid, GridItem,Cell, CellGroup,SwipeCell,Button,NavBar} from 'vant';
  
  export default {
    data(){
      return{
        active: 0,
        list:[],
        alist: [],
        page:1,
        channel_id:'',
        user_id:'',
        loading: false,
        finished: false,
        num:10,
        ask_nums:0,
        comment_nums:0,
        img: {
         parise: require('../../../assets/img/parise.png'),
         parise_have: require('../../../assets/img/parise_have.png'),
         comment: require('../../../assets/img/comment.png'),
         avatar: require('../../../assets/img/default.jpg'),
         question: require('../../../assets/img/question.png'),
         answer: require('../../../assets/img/answers.png'),
       }
     }

   },
   computed: {
    ...mapState({
      source: state => state.param.source
    })
  },
  created () {
    this.$store.commit('param/show', false)
    this.channel_id = this.$route.params.id
    if(!Lockr.get('token')) {

      if(this.source == 3||this.source == 7) {
        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
          } else {
            this.$appService.needLogin()
          }
        })
      }

      this.$toast('请先登录')
      return false
    }
    if(this.source == 3||this.source == 7) {
      this.$appService.isShowReturn({state: true})
    }

    let params={
      channel_id:this.channel_id,
      page:this.page,
    }
    this.getComments(params)
    this.getNoticenum(this.channel_id)
    var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
  },
  methods: {
    onClick(name){
      if(name==0){
        this.list=[]
        this.page=1
        let params={
         channel_id:"",
         page:1
       }
       this.getComments(params)
     }else if(name==1){
      this.alist=[]
      this.page=1
      let params={
        channel_id:"",
        page:1
      }
      this.getAnswer(params)
    }
  },
  getNoticenum(channelid){
    list.getNoticenum(channelid).then(res => {
      if(res.data.state == 1) {
        this.ask_nums=res.data.ask_nums
        this.comment_nums=res.data.comment_nums 
      }
    })
  },
  getComments(params){
    list.getComments(params).then(res => {
      if(res.data.state == 1) {
        let list=this.list
        let newlist=res.data.data.data
        if(list.length==0){
          this.list = res.data.data.data
        }else{
          this.num=newlist.length
          this.list = this.list.concat(newlist)
        }
      }
    })
  },
  getAnswer(params){
    list.getAnswer(params).then(res => {
      if(res.data.state == 1) {
        let alist=this.alist
        let newlist=res.data.data.data
        if(alist.length==0){
          this.alist = res.data.data.data
        }else{
          this.num=newlist.length
          this.alist = this.alist.concat(newlist)
        }

      }
    })
  },
  delMessage(e){
    let id=e.currentTarget.dataset.code
    let name=e.currentTarget.dataset.name
    this.$dialog.confirm({
      message: '确定要删除吗？'
    }).then(() => {
      if(name==0){
        list.delMessage(id).then(res => {
          if(res.data.state == 1) {
            let list=this.list
            for (var i=0;i<list.length;i++) {
              if(list[i].comment_id==id){
               list.splice(i, 1)
             }
           }
           this.list=list
           this.$toast.success('删除成功');
         }
       })
      }else{
       list.delMessage(id).then(res => {
        if(res.data.state == 1) {
          let alist=this.alist
          for (var i=0;i<alist.length;i++) {
            if(alist[i].id==id){
             alist.splice(i, 1)
           }
         }
         this.alist=alist
         this.$toast.success('删除成功');
       }
     })
     }
   }).catch(() => {
   });
 },
 onClickLeft(){
  this.$router.go(-1)
},
onLoad() {
  setTimeout(() => {
    let num=this.num
    if (num <10) {
      this.finished = true
      this.loading = false
    }else{
      this.page=this.page+1
      let params={
        channel_id:"",
        page:this.page
      }
      if(this.active==0){
        this.getComments(params)
      }else if(this.active==1){
        this.getAnswer(params)
      }

      this.loading = false
    }
  }, 500);
},
},
components: {
  [Row.name]: Row,
  [Col.name]: Col,
  [Grid.name]: Grid,
  [GridItem.name]: GridItem,
  [List.name]: List,
  [Tabs.name]: Tabs,
  [Tab.name]: Tab,
  [Tag.name]: Tag,
  [Cell.name]: Cell,
  [CellGroup.name]: CellGroup,
  [SwipeCell.name]:SwipeCell,
  [Button.name]:Button,
  [NavBar.name]:NavBar
}
}
</script>

<style lang="scss">
.message{
  // .van-nav-bar__left {
  //  left: 10px;
  // }
  .listhand{
    padding: 15px;
    border-bottom: 1px solid #eaeaea;
    color: #9A9A9A;
  }
  .van-cell{
    border-bottom:1px solid #eaeaea;
  }
  .van-tag{
    padding: 2px;
    float: right;
    margin-top: 80%;
  }
  .sourtime{
    color: #9A9A9A;
  }
  .van-button--square {
    height: 100%;
  }
}


</style>
